// import moment from "moment";
/* Importing the locales for moment.js. */
// import "moment/locale/ar";
// import "../config/moment/locale/ar-iq";
// import "moment/locale/de";
// import "moment/locale/fr";
// import "moment/locale/tr";
import dayjs from "dayjs";


const useFormattedDate = (longFormat) => {
  const formatDate = (date?: string | number | dayjs.Dayjs | Date) => {
    return longFormat
      ? dayjs(date).format("llll")
      : dayjs(date).utc().fromNow();
  };
  return { formatDate };
};

export default useFormattedDate;
